<template>
  <div class="lg:px-20 md:px-12 px-5 lg:py-16 md:py-12 py-8">
    <div class="pt-4 pb-8 lg:px-20 md:px-20 px-5 absolute top-0 left-0 z-10">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Resources</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16">Gallery</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      class="lg:w-1/2 md:w-2/3 w-full mx-auto text-center lg:mb-16 md:mb-10 mb-6"
    >
      <h2
        class="bg-white font-semibold fsize40 md-fsize28 sm-fsize20 clr-black"
      >
        Gallery
      </h2>
    </div>

    <div
      class="w-full grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-10 md:gap-10 gap-6 cursor-pointer"
    >
      <div
        class="rounded-xl p-8 bg-f4f5f6"
        v-for="album in albums"
        :key="album._id"
      >
        <div @click="handleRedirect(album)">
          <div v-if="album.images[0]">
            <div class="relative w-full">
              <img
                :src="`${$imageURL}/${album.images[0]}`"
                alt="img"
                class="lg:h-56 h-48 w-full rounded-xl object-contain"
              />
            </div>
            <div class="pt-3">
              <p class="font-bold text-black fsize16">
                <!-- Event Name : -->
                {{
                  album.hasOwnProperty("eventName") && album.eventName
                    ? album.eventName.title
                    : "No Title"
                }}
              </p>
              <p class="fsize16 ellipsis-3">
                {{ album.albumDescription }}
              </p>
            </div>
          </div>
          <div v-else>
            <div class="relative w-full">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                alt="img"
                class="w-full lg:h-56 h-48 rounded-lg object-contain"
              />
            </div>
            <div class="pt-3">
              <p class="font-bold text-black fsize16">
                <!-- Event Name : -->
                {{
                  album.hasOwnProperty("eventName") && album.eventName
                    ? album.eventName.title
                    : "No Title"
                }}
              </p>
              <p class="fsize16 ellipsis-3">
                {{ album.albumDescription }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      albums: {},
    };
  },
  methods: {
    async dataLoad() {
      const galleryData = await this.$store.dispatch("gallery/getAllGalleries");
      this.albums = galleryData.data.albums;
    },
    handleRedirect(album) {
      this.$router.push({
        name: "gallery-singlepage",
        params: { id: album._id },
      });
    },
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
